import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import DrawerViewShareWithAllInfo from '@app/src/components/Drawer/Views/DrawerViewShareWithAllInfo'
import { Language } from '@mui/icons-material'
import { Avatar, ButtonBase, Link, ListItem, ListItemAvatar, ListItemText, Switch } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type ShareWithNetworkDrawerItemProps = {
  onClick: () => void
  isChecked: boolean
  isCustomerNetwork?: boolean
  showLearnMore?: boolean
  requestTitle?: string
}

const ShareWithNetworkDrawerItem: React.FC<ShareWithNetworkDrawerItemProps> = ({
  onClick,
  isChecked,
  isCustomerNetwork,
  showLearnMore,
  requestTitle,
}) => {
  const { formatMessage } = useIntl()
  const { openDrawer } = useDrawer()

  return (
    <ListItem secondaryAction={<Switch color="primary" checked={isChecked} onClick={onClick} />} sx={{ py: 2, pl: 0 }}>
      <ListItemAvatar>
        <Avatar
          sx={({ palette }) => ({
            bgcolor: palette.secondary.main,
            color: 'background.paper',
            borderRadius: '50%',
          })}
        >
          <Language />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          isCustomerNetwork
            ? formatMessage({ id: 'reporting.sharing.visibleToGroupNetwork' })
            : formatMessage({ id: 'reporting.sharing.visibleToWfNetwork' })
        }
        secondary={
          showLearnMore && (
            <Link
              component={ButtonBase}
              variant="caption"
              color="textSecondary"
              onClick={() => openDrawer(<DrawerViewShareWithAllInfo subTitle={requestTitle} />)}
            >
              {formatMessage({ id: 'general.learnMore' })}
            </Link>
          )
        }
      />
    </ListItem>
  )
}

export default ShareWithNetworkDrawerItem
